
import React, { useEffect, useState , useRef} from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import "../Pages/CSS/ShopCategory.css";
import dropdown_icon from "../Components/Assets/Frontend_Assets/dropdown_icon.png";
import Item from "../Components/Item/Item.jsx";
import placeholder from "../Components/Assets/Frontend_Assets/placeholder.jpg";
import { useNavigate } from "react-router-dom";
import men_banner from '../Components/Assets/Frontend_Assets/banner_mens.png'
import women_banner from '../Components/Assets/Frontend_Assets/banner_women.png'
import kids_banner from '../Components/Assets/Frontend_Assets/banner_kids.png'
import stitchedImg from "../Components/Assets/Frontend_Assets/stitched.jpeg";
import unstitchedImg from "../Components/Assets/Frontend_Assets/unstitched.jpg";
import accessoriesImg from "../Components/Assets/Frontend_Assets/accessories.jpg"; 
 import solidImg from "../Components/Assets/Frontend_Assets/solid.jpg";
import printedImg from "../Components/Assets/Frontend_Assets/printed.jpg";
import embroideredImg from "../Components/Assets/Frontend_Assets/embroidered.jpg";
import BASE_URL from '../Config/api.js';
const LIMIT = 40;

const ShopCategory = ({ banner, category }) => {
  const navigate = useNavigate();

  const { main, type, fabric, brandName } = useParams();
  
const bannerMap = {
  men: men_banner,
  women: women_banner,
  kids: kids_banner,
};

// Convert to lowercase to ensure it matches keys, 
// and provide a default fallback image
const bannerImage = bannerMap[main?.toLowerCase()];
  const location = useLocation();
   // Get first path segment
 const pathParts = location.pathname.split("/").filter(Boolean);

// detect main category safely
let mainCategory = "";

if (pathParts.includes("men")) {
  mainCategory = "men";
} else if (pathParts.includes("women")) {
  mainCategory = "women";
} else if (pathParts.includes("kids")) {
  mainCategory = "kids";
}

let bannerText = "";
let salogen = "";

switch (mainCategory) {
  case "men":
    bannerText = "MEN COLLECTION";
    salogen = "Classic & Modern Wear";
    break;

  case "women":
    bannerText = "WOMEN COLLECTION";
    salogen = "Elegant & Stylish Fashion";
    break;

  case "kids":
    bannerText = "KIDS COLLECTION";
    salogen = "Comfort & Fun Styles";
    break;

  default:
    bannerText = "";
    salogen = "";
}
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get("page")) || 1;
  const search = searchParams.get("search") || "";

  const activeMain = category || main;

  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  const [sortType, setSortType] = useState("default");
  const [showSort, setShowSort] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  /* ---------------- FILTER STATE ---------------- */
  const [filters, setFilters] = useState({
    colors: [],
    clothTypes: [],
    types: [],
    pieces: [],
    minPrice: "",
    maxPrice: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    colors: [],
    clothTypes: [],
    types: [],
    pieces: [],
    minPrice: 0,
    maxPrice: 0,
    fabrics: [],
  });
  const sortRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (e) => {
    if (sortRef.current && !sortRef.current.contains(e.target)) {
      setShowSort(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  /* ---------------- RESET FILTERS ON ROUTE CHANGE ---------------- */
  useEffect(() => {
    setFilters({
      colors: [],
      clothTypes: [],
      types: type ? [type] : [],
      pieces: [],
      minPrice: "",
      maxPrice: "",
    });
    setSearchParams({});
  }, [location.pathname, type, setSearchParams]);

  /* ---------------- FETCH FILTER OPTIONS ---------------- */
  useEffect(() => {
    fetch(`${BASE_URL}/allproducts?main=${activeMain}&limit=1000`)
      .then(res => res.json())
      .then(data => {
        const colors = {};
        const clothTypes = {};
        const pieces = {};
        const types = {};
        const fabrics = {};
        let min = Infinity, max = 0;

        data.products.forEach(p => {
          if (p.color) colors[p.color] = (colors[p.color] || 0) + 1;
          if (p.cloth_type) clothTypes[p.cloth_type] = (clothTypes[p.cloth_type] || 0) + 1;
          if (p.type) types[p.type] = (types[p.type] || 0) + 1;
          if (p.pieces?.length) {
            p.pieces.forEach(x => pieces[x] = (pieces[x] || 0) + 1);
          }
          if (p.fabric_type) fabrics[p.fabric_type] = (fabrics[p.fabric_type] || 0) + 1;
          min = Math.min(min, p.new_price);
          max = Math.max(max, p.new_price);
        });

        setFilterOptions({
          colors: Object.entries(colors).map(([name, count]) => ({ name, count })),
          clothTypes: Object.entries(clothTypes).map(([name, count]) => ({ name, count })),
          types: Object.entries(types).map(([name, count]) => ({ name, count })),
          pieces: Object.entries(pieces).map(([name, count]) => ({ name, count })),
          fabrics: Object.entries(fabrics).map(([name, count]) => ({ name, count })),
          minPrice: min,
          maxPrice: max,
        });

        setFilters(f => ({ ...f, minPrice: min, maxPrice: max }));
      });
  }, [activeMain]);

  /* ---------------- FETCH PRODUCTS ---------------- */
  useEffect(() => {
    setLoading(true);

  //   const params = new URLSearchParams({
  //     page,
  //     limit: LIMIT,
  //     main: activeMain,
  //     type: filters.types.join(","),
  //     fabric: fabric || "",
  //     search,
  //     colors: filters.colors.join(","),
  //     clothTypes: filters.clothTypes.join(","),
  //     pieces: filters.pieces.join(","),
  //     minPrice: filters.minPrice,
  //     maxPrice: filters.maxPrice,
  //   });

  //   fetch(`${BASE_URL}/allproducts?${params}`)
  //     .then(res => res.json())
  //     .then(data => {
  //       setProducts(data.products);
  //       setTotal(data.total);
  //       setLoading(false);
  //     });
  // }, [activeMain, type, fabric, page, search, filters]);
 const params = new URLSearchParams({
    page,
    limit: LIMIT,
    search,
    colors: filters.colors.join(","),
    clothTypes: filters.clothTypes.join(","),
    pieces: filters.pieces.join(","),
    minPrice: filters.minPrice,
    maxPrice: filters.maxPrice,
  });

  // 🔥 BRAND PAGE
if (brandName) {
  params.append("main", main);
  params.append("brand", brandName);
}
else if (main) {
  params.append("main", main);
  if (type) params.append("type", type);
  if (fabric) params.append("fabric", fabric);
}

  fetch(`${BASE_URL}/allproducts?${params}`)
    .then(res => res.json())
    .then(data => {
      setProducts(data.products);
      setTotal(data.total);
      setLoading(false);
    });

}, [main, type, fabric, page, search, filters, brandName]);
  /* ---------------- SORT ---------------- */
  const sortedProducts = [...products].sort((a, b) => {
    switch (sortType) {
      case "low-high": return a.new_price - b.new_price;
      case "high-low": return b.new_price - a.new_price;
      case "az": return a.product_name.localeCompare(b.product_name);
      case "za": return b.product_name.localeCompare(a.product_name);
      default: return 0;
    }
  });

  /* ---------------- CHECKBOX HANDLER ---------------- */
  const handleCheck = (key, val) => {
    setFilters(f => ({
      ...f,
      [key]: f[key].includes(val)
        ? f[key].filter(x => x !== val)
        : [...f[key], val]
    }));
  };

  /* ---------------- CLEAR FILTER ---------------- */
  const clearFilters = () => {
    setFilters({
      colors: [],
      clothTypes: [],
      types: type ? [type] : [],
      pieces: [],
      minPrice: filterOptions.minPrice,
      maxPrice: filterOptions.maxPrice,
    });
  };

  const totalPages = Math.ceil(total / LIMIT);


 const ITEMS_PER_PAGE = 5;
const [fabricIndex, setFabricIndex] = useState(0);
const getVisibleItems = (items) =>
  items.slice(fabricIndex, fabricIndex + ITEMS_PER_PAGE);

 
  return (
    <div className="shop-category">
      {banner && (<div className="shop-banner-wrapper"><div className="category-text"><h2>{bannerText}</h2><p>{salogen}</p></div><img src={banner} className="shop-banner" alt="Banner" /></div>)}
      {bannerImage &&(<div className="shop-banner-wrapper"><div className="category-text"><h2>{bannerText}</h2><p>{salogen}</p></div> <img src={bannerImage} className="shop-banner" alt="" /></div>)}
    
      <div className="top-filter-bar">

        {/* ================= GROUP 1 ================= */}
        {!type && (
          <div className="filter-group first_filter">

            {/* TYPE IMAGE CARDS */}
            <div className="type-grid">
              {[
                { key: "stitched", label: "Stitched", img: stitchedImg },
                { key: "unstitched", label: "Unstitched", img: unstitchedImg },
                { key: "accessories", label: "Accessories", img: accessoriesImg },
              ].map(item => (
                <div
                  key={item.key}
                  className="type-card"
                  onClick={() => navigate(`/category/${activeMain}/${item.key}`)}
                >
                  <div className="type-image">
                    <img src={item.img} alt={item.label} />
                  </div>
                  <div className="type-label">{item.label}</div>
                </div>
              ))}
                {[
                { name: "printed", label: "Printed", img: printedImg  },
                { name: "solid", label: "Solid", img: solidImg },
                { name: "embroidered", label: "Embroidered", img: embroideredImg  },
              ].map(c => (
                <div
                  key={c.name}
                  className="cloth-card"
                  onClick={() =>
                    setFilters(f => ({
                      ...f,
                      clothTypes: [c.name],
                    }))
                  }
                >
                  <div className="cloth-image">
                    <img src={c.img} alt={c.label} />
                  </div>
                  <div className="cloth-label">{c.label}</div>
                </div>
              ))} 
            </div>

          </div>
        )}

      {type && (
        <div className="filter-group">

          {/* ---------- FABRIC BUTTONS ---------- */}
          {!fabric && (
            <div className="filter-row slider-row">
            

              {/* PREV BUTTON */}
              {fabricIndex > 0 && (
                <button
                  className="slide-btn"
                  onClick={() =>
                    setFabricIndex(i => Math.max(i - ITEMS_PER_PAGE, 0))
                  }
                >
                  ◀
                </button>
              )}

              {/* FABRIC BUTTONS */}
              {getVisibleItems(filterOptions.fabrics).map(f => (
                <button
                  key={f.name}
                  onClick={() =>
                    navigate(`/category/${activeMain}/${type}/${f.name}`)
                  }
                  className="filter-chip"
                >
                  {f.name}
                </button>
              ))}

              {/* NEXT BUTTON */}
              {fabricIndex + ITEMS_PER_PAGE < filterOptions.fabrics.length && (
                <button
                  className="slide-btn"
                  onClick={() =>
                    setFabricIndex(i => i + ITEMS_PER_PAGE)
                  }
                >
                  ▶
                </button>
              )}
            </div>
          )}

          {/* ---------- OTHER FABRICS ---------- */}
          {fabric && (
            <div className="filter-row slider-row">
            

              {fabricIndex > 0 && (
                <button
                  className="slide-btn"
                  onClick={() =>
                    setFabricIndex(i => Math.max(i - ITEMS_PER_PAGE, 0))
                  }
                >
                  ◀
                </button>
              )}

              {getVisibleItems(
                filterOptions.fabrics.filter(
                  f => f.name.toLowerCase() !== fabric.toLowerCase()
                )
              ).map(f => (
                <button
                  key={f.name}
                  onClick={() =>
                    navigate(`/category/${activeMain}/${type}/${f.name}`)
                  }
                  className="filter-chip outline"
                >
                  {f.name}
                </button>
              ))}

              {fabricIndex + ITEMS_PER_PAGE <
                filterOptions.fabrics.filter(
                  f => f.name.toLowerCase() !== fabric.toLowerCase()
                ).length && (
                <button
                  className="slide-btn"
                  onClick={() =>
                    setFabricIndex(i => i + ITEMS_PER_PAGE)
                  }
                >
                  ▶
                </button>
              )}
            </div>
          )}

        </div>
      )}

      </div>


      {/* ---------------- TOOLBAR ---------------- */}
      <div className="shopcategory-indexSort">
        <div className="d-flex">
           <button className="filter-btn" onClick={() => { setShowFilter(true); setShowSort(false); }}>
          Filters
        </button>
        <p><span>{total}</span> Products</p>
       
        </div>
        <div className="toolbar-right d-flex">
          {/* <button onClick={() => setShowFilter(true)}>Filters</button> */}
        

          {/* <div className="sort-wrapper"> */}
              {/* ----------------  SEARCH ---------------- */}
                  <input
                    className="shop-search"
                    placeholder="Search products..."
                    value={search}
                    onChange={(e) =>
                      e.target.value.trim()
                        ? setSearchParams({ search: e.target.value, page: 1 })
                        : setSearchParams({})
                    }
                  />
          <div className="sort-wrapper" ref={sortRef}>
        
            <div className="shopcategory-sort" onClick={() => setShowSort(!showSort)}>
              Sort <img src={dropdown_icon} alt="" />
            </div>
            {/* {showSort && (
              <div className="sort-menu">
                <p onClick={() => setSortType("low-high")}>Price: Low → High</p>
                <p onClick={() => setSortType("high-low")}>Price: High → Low</p>
                <p onClick={() => setSortType("az")}>Name: A → Z</p>
                <p onClick={() => setSortType("za")}>Name: Z → A</p>
              </div>
            )} */}
            {showSort && (
            <div className="sort-menu">
              <p onClick={() => { setSortType("low-high"); setShowSort(false); }}>
                Price: Low → High
              </p>
              <p onClick={() => { setSortType("high-low"); setShowSort(false); }}>
                Price: High → Low
              </p>
              <p onClick={() => { setSortType("az"); setShowSort(false); }}>
                Name: A → Z
              </p>
              <p onClick={() => { setSortType("za"); setShowSort(false); }}>
                Name: Z → A
              </p>
            </div>
          )}

          </div>
        </div>
      </div>

      {/* ---------------- PRODUCT GRID ---------------- */}
      <div className="shopcategory-products four-grid">
        {loading
          ? Array.from({ length: 8 }).map((_, i) => <div className="skeleton-card" key={i} />)
          : sortedProducts.map(p => (
              <Item
              key={p.product_id}
              id={p.product_id}
              image={p.image || placeholder}
              product_name={p.product_name}
              productCode={p.product_code}
              pieces={p.pieces?.length ? `${p.pieces.length} Piece` : ""}
              clothType={p.cloth_type}
               brandname={p.brandname}
              type={p.type?.toUpperCase()}
              isNew={p.is_new}
              new_price={p.new_price}
              old_price={p.old_price}
            />
            ))
        }
      </div>

      {/* ---------------- PAGINATION ---------------- */}
      {totalPages > 1 && (
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              className={page === i + 1 ? "active" : ""}
              onClick={() => setSearchParams({ page: i + 1 })}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}

      {/* ---------------- FILTER MODAL ---------------- */}
      {showFilter && (
        // <div className="filter-modal">
        //   <div className="filter-content">
      
  <div
    className="filter-modal"
    onClick={() => setShowFilter(false)}   // 👈 outside click
  >
    <div
      className="filter-content"
      onClick={(e) => e.stopPropagation()} // 👈 prevent close inside
    >

            <button className="close-filter" onClick={() => setShowFilter(false)}>×</button>

            <h3>Filters</h3>

            <div className="filter-section">
              <h4>Price Range</h4>
              <div className="price-range">
                <input type="number" value={filters.minPrice}
                  onChange={e => setFilters(f => ({ ...f, minPrice: e.target.value }))} />
                <span>—</span>
                <input type="number" value={filters.maxPrice}
                  onChange={e => setFilters(f => ({ ...f, maxPrice: e.target.value }))} />
              </div>
            </div>

            <div className="filter-section">
              <h4>Type</h4>
              {filterOptions.types.map(t => (
                <label key={t.name}>
                  <input
                    type="checkbox"
                    checked={filters.types.includes(t.name)}
                    onChange={() => handleCheck("types", t.name)}
                  />
                  {t.name} ({t.count})
                </label>
              ))}
            </div>

            <div className="filter-section">
              <h4>Cloth Type</h4>
              {filterOptions.clothTypes.map(c => (
                <label key={c.name}>
                  <input
                    type="checkbox"
                    checked={filters.clothTypes.includes(c.name)}
                    onChange={() => handleCheck("clothTypes", c.name)}
                  />
                  {c.name} ({c.count})
                </label>
              ))}
            </div>

            <div className="filter-section">
              <h4>Fabric Type</h4>
              {filterOptions.fabrics.map(f => (
                <label key={f.name}>
                  <input
                    type="checkbox"
                    checked={filters.fabric?.includes(f.name)}
                    onChange={() => handleCheck("fabric", f.name)}
                  />
                  {f.name} ({f.count})
                </label>
              ))}
            </div>

            <div className="filter-section">
              <h4>Color</h4>
              {filterOptions.colors.map(c => (
                <label key={c.name}>
                  <input
                    type="checkbox"
                    checked={filters.colors.includes(c.name)}
                    onChange={() => handleCheck("colors", c.name)}
                  />
                  {c.name} ({c.count})
                </label>
              ))}
            </div>

            <div className="filter-section">
              <h4>Pieces</h4>
              {filterOptions.pieces.map(p => (
                <label key={p.name}>
                  <input
                    type="checkbox"
                    checked={filters.pieces.includes(p.name)}
                    onChange={() => handleCheck("pieces", p.name)}
                  />
                  {p.name} ({p.count})
                </label>
              ))}
            </div>

            <div className="filter-buttons">
              <button className="apply-filter" onClick={() => setShowFilter(false)}>Apply</button>
              <button className="clear-filter" onClick={clearFilters}>Clear</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopCategory;

